var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import 'whatwg-fetch';
import Jsona from 'jsona';
import i18n from 'i18next';
import qs from 'qs';
import { getCredentials, setCredentials, setCurrentUser, } from '../localStorage';
var formatter = new Jsona();
var Endpoint = TYPICA_BACKEND_URL || 'http://localhost:3000';
var updateCredentials = function (responseHeaders, requestHeaders) {
    var token = responseHeaders.get('access-token') || '';
    var expiry = parseInt(responseHeaders.get('expiry') || '0');
    var uid = responseHeaders.get('uid') || '';
    var client = responseHeaders.get('client') || '';
    var requestUid = requestHeaders.uid;
    var requestClient = requestHeaders.client;
    var requestExpiry = parseInt(requestHeaders.expiry || '0');
    if (client &&
        token &&
        uid &&
        expiry &&
        (!requestUid ||
            (requestUid === uid &&
                (requestClient !== client || requestExpiry < expiry)))) {
        setCredentials({
            token: token,
            expiry: expiry,
            uid: uid,
            client: client,
        });
    }
};
export var clearCredentials = function () {
    setCurrentUser(undefined);
    setCredentials(undefined);
};
var AppVersionMismatchError = /** @class */ (function (_super) {
    __extends(AppVersionMismatchError, _super);
    function AppVersionMismatchError(version) {
        var _this = _super.call(this) || this;
        _this.version = version;
        _this.name = 'AppVersionMismatchError';
        Object.setPrototypeOf(_this, AppVersionMismatchError.prototype);
        return _this;
    }
    return AppVersionMismatchError;
}(Error));
export { AppVersionMismatchError };
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(response, body) {
        var _this = _super.call(this) || this;
        _this.response = response;
        _this.body = body;
        _this.name = 'ResponseError';
        _this.getErrors = function () {
            if (_this.body) {
                try {
                    var json = JSON.parse(_this.body);
                    if (json['errors'])
                        return json['errors'];
                }
                catch (error) {
                    // nop
                }
            }
            return [_this.response.statusText];
        };
        _this.toString = function () { return _this.response.statusText; };
        Object.setPrototypeOf(_this, ResponseError.prototype);
        return _this;
    }
    return ResponseError;
}(Error));
export { ResponseError };
var setupHeaders = function (form) {
    var base = form
        ? {}
        : {
            'Content-Type': 'application/json',
        };
    var credentials = getCredentials();
    if (credentials) {
        base['access-token'] = credentials.token;
        base['client'] = credentials.client;
        base['uid'] = credentials.uid;
    }
    base['X-Typica-Lang'] = i18n.language;
    return base;
};
var checkStatus = function (response, requestHeader) { return __awaiter(void 0, void 0, void 0, function () {
    var apiVersion, body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                updateCredentials(response.headers, requestHeader);
                apiVersion = response.headers.get('X-App-Version');
                if (apiVersion && apiVersion !== VERSION)
                    throw new AppVersionMismatchError(apiVersion);
                if (response.status >= 200 && response.status < 300) {
                    return [2 /*return*/, response];
                }
                if (response.status === 401)
                    clearCredentials(); // clear session
                return [4 /*yield*/, response.text()];
            case 1:
                body = _a.sent();
                throw new ResponseError(response, body);
        }
    });
}); };
export default function request(path, method, data, options) {
    if (method === void 0) { method = 'get'; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, noDeserialize, isForm, fetchParams, query, response, json, responseData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = options || {}, headers = _a.headers, noDeserialize = _a.noDeserialize;
                    isForm = data instanceof FormData;
                    fetchParams = {
                        method: method,
                        mode: 'cors',
                        headers: __assign(__assign({}, setupHeaders(isForm)), (headers || {})),
                    };
                    query = '';
                    if (data) {
                        if (method === 'get') {
                            query = "?".concat(qs.stringify(data, { arrayFormat: 'brackets' }));
                        }
                        else {
                            fetchParams.body = isForm ? data : JSON.stringify(data);
                        }
                    }
                    return [4 /*yield*/, fetch("".concat(Endpoint).concat(path).concat(query), fetchParams)];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, checkStatus(response, fetchParams.headers)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _b.sent();
                    responseData = noDeserialize ? json : formatter.deserialize(json);
                    return [2 /*return*/, { data: responseData, meta: json.meta }];
            }
        });
    });
}
export function getBinary(path, params) {
    return __awaiter(this, void 0, void 0, function () {
        var fetchParams, queryString, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchParams = {
                        method: 'get',
                        mode: 'cors',
                        headers: __assign({}, setupHeaders(false)),
                    };
                    queryString = params
                        ? qs.stringify(params, { arrayFormat: 'brackets' })
                        : '';
                    return [4 /*yield*/, fetch("".concat(Endpoint).concat(path, "?").concat(queryString), fetchParams)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, checkStatus(response, fetchParams.headers)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, response.blob()];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
